var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classes,style:(_vm.itemStyle),on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[(!!_vm.tooltip&&_vm.parent.collapse)?_c('Tooltip',{attrs:{"popper-class":_vm.popperClass,"transfer":"","content":_vm.tooltip,"placement":"right"}},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/menu/menu-item.vue